import '@babel/polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import 'slick-carousel';
import '@fancyapps/fancybox';
import Inputmask from 'inputmask';
import 'select2';
import likely from 'ilyabirman-likely';
import 'scrolltofixed';

svg4everybody();
likely.initiate();

window.$ = $;
window.jQuery = $;
window.gsap = gsap;

let obj = [];

$(window).on('load', () => {
	$('.s-main').addClass('js-load');
});

(function ($) {
	$(document).ready(
		() => {
			animateLogo();
			eventClick();
			slickCarousel();
			dropdown();
			btnShare();
			showModal();
			closeModal();
			select();
			file();
			modal();
			scrollFixed();
			yearClick();
			employeeTab();
			menuHover();
			infoMascot();
			projectsMore();
		},
	);

	$(document).mouseup((e) => {
		dropdownHide(e);
	});

	$(window).on('resize',
		() => {
			scrollFixed();
			yearClick();
		},
	);

	$(window).on('scroll',
		() => {
			imageDescBlur();
			onScroll();
			inviteClip();
		},
	);
})(jQuery);

function inviteClip() {
	const ibvite = document.querySelector('.b-invite');
	if (ibvite) {
		const ibviteBox = $('.b-invite__img__clip');
		if ($(window).scrollTop() + $(window).height() >= ibviteBox.offset().top) {
			let top = $(window).scrollTop() + $(window).height() - ibviteBox.offset().top;
			let left = top / 100 * 20;
			ibviteBox.css('backgroundPosition', `${-left}px 0`);
		}
	}
}

function onScroll(event) {
	let scrollPos = $(document).scrollTop();
	let topSize = 48;

	if ($(window).width() <= '767') {
		topSize = 150;
	}

	$('.b-history__year__list a').each(function () {
		let currLink = $(this);
		let refElement = $(currLink.attr('href'));

		if (refElement.position().top - topSize <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
			let current = currLink.data('item');

			$('.b-history__year__item a').removeClass('is-active');
			currLink.addClass('is-active');

			if ($(window).width() <= '767') {
				 $('.js-year-carousel').slick('slickGoTo', current, true);
			}
		}
	});
}

function yearClick() {
	if ($(window).width() <= '767') {
		$('.js-year-carousel').on('click', '.slick-slide', function () {
			let link = $(this).find('a');
			let topSize = 120;
			let current = link.data('item');

			$('html, body').stop().animate({
				scrollTop: $(link.attr('href')).offset().top - topSize,
			}, 700);

			return false;
		});
	} else {
		$('.b-history__year__item a').bind('click', function () {
			let topSize = 48;

			$('html, body').stop().animate({
				scrollTop: $($(this).attr('href')).offset().top - topSize,
			}, 700);

			return false;
		});
	}
}

function scrollFixed() {
	let navFunc = $('.b-nav-func__frame');
	let listFixed = $('.b-history__year__list');
	let topSize = 90;

	if ($(window).width() <= '767') {
		topSize = 48;
	}

	listFixed.trigger('detach.ScrollToFixed');
	listFixed.scrollToFixed({
		marginTop: topSize,
		limit: $('.s-footer').offset().top - 500,
	});

	navFunc.trigger('detach.ScrollToFixed');
	navFunc.scrollToFixed({
		marginTop: 100,
		limit: $('.s-footer').offset().top - 800,
	});
}

function modal() {
	$('[data-fancybox]').fancybox({
		touch: false,
	});
}

function select() {
	$('.js-select').select2({
		minimumResultsForSearch: -1,
	});
}

function file() {
	$('.form-file__input').change(() => {
		$('.form-file__title').text($('.form-file__input')[0].files[0].name);
	});
}

function showModal() {
	$('.js-showModal').on('click', () => {
		$('body').addClass('is-noScroll');
		$('.b-wrapModal').show(0);
	});
}

function closeModal() {
	$('.js-closeModal').on('click', () => {
		$('body').removeClass('is-noScroll');
		$('.b-wrapModal').hide();
	});
}

function btnShare() {
	$('.b-btnShare__btn').on('click', function () {
		$(this).next('.b-btnShare__list').slideToggle(0);
	});
}

function animateLogo() {
	const logo = setInterval(() => {
		const lg = $('.s-header .logo');
		const cl = 'is-slogan';
		if (lg.hasClass(cl)) {
			lg.removeClass(cl);
		} else {
			lg.addClass(cl);
		}
	}, 5000);
}

function animateScroll(e) {
	$('html, body').stop().animate({
		scrollTop: $(e.attr('href')).offset().top - 48,
	}, 700);

	return false;
}

function eventClick(e) {
	$('a.btn-up').bind('click', function () {
		animateScroll($(this));
	});

	$('.js-sec-show').on('click', () => {
		$('.b-search-form__where__select').show();
	});

	$('.js-sec-hide').on('click', () => {
		$('.b-search-form__where__select').hide();
	});

	$('a.js-scroll').bind('click', function () {
		if (imgDesc) {
			imgDesc.forEach((e, i) => {
				e.style.minHeight = `${obj[i]}px`;
			});
		}
		animateScroll($(this));
		setTimeout(() => {
			if (imgDesc) {
				imgDesc.forEach((e, i) => {
					e.style.minHeight = 'auto';
				});
			}
		}, 1000);
	});

	$('.b-accordion__item__title').on('click', function () {
		$(this).toggleClass('is-open');
		$(this).next('.b-accordion__item__frame').slideToggle();
	});

	$('.b-pageBar__btn').on('click', () => {
		$('.b-pageBar').toggleClass('is-open');
	});

	$('.b-barTop__title').on('click', () => {
		$('.b-barTop__nav').toggleClass('is-open');
	});

	$('.s-content--video > .container').on('click', () => {
		$('.b-barTop__nav').removeClass('is-open');
	});

	$('.b-employee-tab__current').on('click', function () {
		$(this).toggleClass('is-open');
	});
}

function slickCarousel() {
	$('.b-award').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		prevArrow: '<button type="button" class="slick-prev"><svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.35145 10.5742L3.77145 6.12765L8.35145 1.68112L6.94145 0.315186L0.941406 6.12765L6.94145 11.9401L8.35145 10.5742Z"/></svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.441406 10.5742L5.0214 6.12765L0.441406 1.68112L1.8514 0.315186L7.8514 6.12765L1.8514 11.9401L0.441406 10.5742Z"/></svg></button>',
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: false,
				},
			},
		],
	});

	$('.js-product-carousel').slick({
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 2,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: false,
				},
			},
		],
	});

	$('.b-prod-reviews__icon').slick({
		infinite: true,
		slidesToShow: 8,
		slidesToScroll: 1,
		arrows: false,
		centerMode: true,
		focusOnSelect: true,
		asNavFor: '.js-review-text-carousel, .js-review-image-carousel',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 6,
				},
			},
			{
				breakpoint: 650,
				settings: {
					slidesToShow: 5,
				},
			},
		],
	});

	$('.js-review-text-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		asNavFor: '.js-review-image-carousel, .b-prod-reviews__icon',
	});

	$('.js-review-image-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		asNavFor: '.b-prod-reviews__icon, .js-review-text-carousel',
	});

	$('.arrow-btn_next').click((e) => {
		$('.js-review-text-carousel').slick('slickNext');
	});

	$('.arrow-btn_prev').click((e) => {
		$('.js-review-text-carousel').slick('slickPrev');
	});

	$('.js-partners-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					dots: true,
					arrows: false,
				},
			},
		],
	});

	$('.js-stories-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: false,
				},
			},
		],
	});

	$('.js-image-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	});

	$('.js-image-carousel-2').slick({
		infinite: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
				},
			},
		],
	});

	$('.js-awards-carousel').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: false,
				},
			},
		],
	});

	$('.js-imagesGrid-carousel').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: false,
				},
			},
		],
	});

	$('.js-year-carousel').slick({
		infinite: false,
		slidesToShow: 15,
		slidesToScroll: 1,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 570,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 360,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('.js-employees-carousel').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('.js-planing-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		asNavFor: '.js-planingDesc-carousel',
	});

	$('.js-planingDesc-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.js-planing-carousel',
		arrows: false,
		adaptiveHeight: true,
		fade: true,
		cssEase: 'linear',
		speed: 100,
	});

	$('.js-slide-main-text').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.js-slide-main-prod',
		arrows: false,
		adaptiveHeight: true,
		fade: true,
		cssEase: 'linear',
		speed: 100,
	});

	$('.js-slide-main-prod').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.js-slide-main-text',
		arrows: false,
		adaptiveHeight: true,
		prevArrow: '<button type="button" class="slick-prev"><svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.35145 10.5742L3.77145 6.12765L8.35145 1.68112L6.94145 0.315186L0.941406 6.12765L6.94145 11.9401L8.35145 10.5742Z"/></svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.441406 10.5742L5.0214 6.12765L0.441406 1.68112L1.8514 0.315186L7.8514 6.12765L1.8514 11.9401L0.441406 10.5742Z"/></svg></button>',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: true,
				},
			},
			{
				breakpoint: 480,
				settings: {
					dots: true,
					arrows: false,
				},
			},
		],
	});

	$('.button-next').click((e) => {
		$('.js-planingDesc-carousel').slick('slickNext');
		$('.js-slide-main-text').slick('slickNext');
	});

	$('.button-prev').click((e) => {
		$('.js-planingDesc-carousel').slick('slickPrev');
		$('.js-slide-main-text').slick('slickPrev');
	});

	initProductSlider();
}

function initProductSlider() {
	if ($('.js-slide-products').length) {
		const firstSlide = $('.b3-products__item').get(0);
		const theme = firstSlide.getAttribute('data-theme');
		if (theme == 'dark') {
			$('.b3-products__list').addClass('b3-products__list--dark');
		}
	
		$('.js-slide-products').slick({
			infinite: true,
			arrows: true,
			dots: true,
			appendDots: $('.b3-products__pagination'),
			prevArrow: `
					<button type="button" class="slick-prev">
						<svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 1L13 13L1 25" stroke-width="2" stroke-linecap="round"/>
						</svg>
					</button>`,
			nextArrow: `
				<button type="button" class="slick-next">
					<svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1 1L13 13L1 25" stroke-width="2" stroke-linecap="round"/>
					</svg>
				</button>`,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: false,
					},
				},
			],
		});
	
		$('.js-slide-products').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			const slide = slick.$slides[nextSlide].querySelector('[data-theme]');
			const theme = slide.getAttribute('data-theme');
	
			if (theme == 'dark') {
				event.currentTarget.classList.add('b3-products__list--dark');
			} else {
				event.currentTarget.classList.remove('b3-products__list--dark');
			}
		});
	}
}

function ready() {
	$('.s-main').addClass('js-load');
}

function dropdown() {
	$('.b-dropdown__title').on('click', function () {
		$(this).next().toggleClass('is-open');
	});
}

function dropdownHide(e) {
	let div = $('.b-dropdown');
	let barTop = $('.b-barTop');

	if (div && !div.is(e.target)
		&& div.has(e.target).length === 0) {
		$('.b-dropdown__list').removeClass('is-open');
	}

	// if (barTop && !div.is(e.target)
	// 	&& div.has(e.target).length === 0) {
	// 	$('.b-barTop__nav').removeClass('is-open')
	// }
}

function imageDescBlur() {
	const boxBlur = document.querySelectorAll('.b-imageDesc__item__blur');
	if (boxBlur) {
		boxBlur.forEach((e) => {
			if (e.clientHeight > 128) {
				e.style.opacity = '1';
			} else {
				e.style.opacity = '0';
			}
		});
	}
}

function employeeTab() {
	$('.b-employee-tab ul').delegate('li:not(.is-active)', 'click', function () {
		$(this).addClass('is-active').siblings().removeClass('is-active')
			.parents('.b-employee-desc')
			.find('.b-employee-box')
			.hide()
			.eq($(this).index())
			.fadeIn(150);
		$('.b-employee-tab__current').removeClass('is-open');
		$('.b-employee-tab__current span').text($(this).text());
	});

	$('.b-prod-info__tab__scroll').delegate('.b-prod-info__tab__item:not(.is-active)', 'click', function () {
		$(this).addClass('is-active').siblings().removeClass('is-active')
			.parents('.b-prod-info__row')
			.find('.b-prod-info__box')
			.hide()
			.eq($(this).index())
			.fadeIn(150);
	});
}

function handlerInOut() {
	$('.b-menu-child').toggleClass('is-active');
	$('.menu .is-parent').toggleClass('is-hover');
}

function menuHover() {
	$('.menu .is-parent, .b-menu-child').on('mouseenter mouseleave', handlerInOut);
}

function infoMascot() {
	const isClosed = localStorage.getItem('career-info-hidden');
	if (!isClosed) {
		const trigger = ScrollTrigger.create({
			trigger: $('.b3-slider'),
			start: 'top 50%',
			end: 'bottom 50%',
			onToggle: (self) => {
				if (!self.isActive) {
					$('.b3-info-mascot').addClass('is-active');
				} else {
					$('.b3-info-mascot').removeClass('is-active');
				}
			},
		});

		$('.b3-info-mascot__close, .b3-info-mascot__text, .b3-info-mascot__img').on('click', () => {
			localStorage.setItem('career-info-hidden', true);
			$('.b3-info-mascot').removeClass('is-active');
		 	trigger.kill();
		});
	}
}

function projectsMore() {
	$('.b3-projects__button').on('click', (e) => {
		e.preventDefault();
		$('.b3-projects__item').removeClass('b3-projects__item--hidden');
		$('.b3-projects__action').css('display', 'none');
	});
}

Inputmask({mask: '+7 (999) 999-99-99'}).mask('.js-mask-phone');

gsap.registerPlugin(ScrollTrigger);

const imgDesc = document.querySelectorAll('.b-imageDesc__item');

if (imgDesc) {
	imgDesc.forEach((e, i) => {
		obj[i] = e.firstElementChild.offsetHeight;
		gsap.to(e, {
			height: e.firstElementChild.offsetHeight,
			scrollTrigger: {
				trigger: e,
				start: 'top 70%',
				end: 'top 25%',
				scrub: true,
				markers: false,
				id: 'scrub',
			},
		});
	});
}

// const inviteClip = document.querySelector('.b-invite__img__clip')

// if (inviteClip) {
// 	console.log(111)
// }

ScrollTrigger.create({
	start: 'top -80',
	end: 99999,
	toggleClass: {className: 'is--scrolled',
		targets: '.s-header--fixed, .btn-up, .b-barTop'},
});

ScrollTrigger.create({
	start: 'top -200',
	end: 99999,
	toggleClass: {className: 'is--scrolled',
		targets: '.b-careerImage'},
});

if (!$('.s-main').hasClass('s-main--slider')) {
	ScrollTrigger.create({
		start: 'top -2000',
		end: 99999,
		toggleClass: {className: 'is-white',
			targets: '.s-header'},
	});
}

ScrollTrigger.create({
	start: 'top -1000',
	end: 99999,
	toggleClass: {className: 'is-white',
		targets: '.b-barTop'},
});

ScrollTrigger.create({
	start: 'top -1000',
	end: 99999,
	toggleClass: {className: 'is-top',
		targets: '.b-nav-func__frame'},
});

const bParallax = $('.b-parallax');
const tl = gsap.timeline({
	scrollTrigger: {
		trigger: bParallax,
		start: 'top top',
		end: 'bottom top',
		scrub: true,
	},
});

const bParallaxBt = $('.b-parallax-bt');
const tl2 = gsap.timeline({
	scrollTrigger: {
		trigger: bParallaxBt,
		start: 'bottom bottom',
		end: 'bottom top',
		scrub: true,
	},
});

document.querySelectorAll('.b-parallax-item').forEach((layer) => {
	const depth = layer.dataset.depth;
	const movement = -(layer.offsetHeight * depth);
	tl.to(layer, {y: movement,
		ease: 'none'}, 0);
});

document.querySelectorAll('.b-parallax-bt-item').forEach((layer) => {
	const depth = layer.dataset.depth;
	const movement = -(layer.offsetHeight * depth);
	tl2.to(layer, {y: movement,
		ease: 'none'}, 0);
});
